import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getMyAccount } from '../../../services/account/account-service';
import { scopeForPath } from '../model/route-action';

let accountPromise = null;

/** The signed-in user's account id, fetched once per page load. */
export function loadAccountId() {
    if (!accountPromise) {
        // Promise.resolve().then: a synchronous throw in the service becomes a rejection, never a crash.
        accountPromise = Promise.resolve()
            .then(() => getMyAccount())
            .then(response => {
                const account = response?.account || {};
                const id = account.accountId || String(account.pk || '').replace(/^account#/, '');
                if (!id) throw new Error('no account');
                return id;
            })
            .catch(error => {
                accountPromise = null; // retry on the next render instead of caching the failure
                throw error;
            });
    }
    return accountPromise;
}

/**
 * Which conversation the copilot is in, from the URL: inside `/app/{appId}/...` it is that
 * application; anywhere else it is the account (`account:<accountId>`).
 */
export default function useCopilotScope() {
    const { pathname } = useLocation();
    const [accountId, setAccountId] = useState(null);
    const [accountError, setAccountError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        loadAccountId()
            .then(id => !cancelled && setAccountId(id))
            .catch(() => !cancelled && setAccountError("Couldn't load your account."));
        return () => { cancelled = true; };
    }, []);

    const scope = scopeForPath(pathname, accountId);
    const appId = scope && !scope.startsWith('account:') ? scope : null;
    return { scope, appId, accountId, isAccountScope: Boolean(scope && !appId), error: scope ? null : accountError };
}
